import React from 'react';

interface SecondaryButtonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  type?: 'button' | 'submit' | 'reset';
  className?: string;
  onClick?: (event?: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
  disabled?: boolean;
  color?: string;
}

function SecondaryButton({
  type = 'button',
  className,
  children,
  color = 'bg-skyblue text-dodger-blue',
  ...props
}: SecondaryButtonProps) {
  return (
    <button
      type={type}
      className={`${color} p-3 rounded-large font-semibold disabled:opacity-75 focus:outline-none ${
        className || ''
      }`}
      {...props}
    >
      {children}
    </button>
  );
}

export default SecondaryButton;
